import { useMutation } from 'react-query';
import request from '../../../../../../helpers/request';

const deleteAttachmentsNote = async ({ ids }) => {
  return await Promise.allSettled(
    ids.map((attachmentId) =>
      request.delete(
        `/Access/transport/attachments/${attachmentId}`,
        null,
        'При удалении вложения произошла ошибка',
        'Error'
      )
    )
  );
};

const useDeleteAttachmentsNote = () =>
  useMutation(deleteAttachmentsNote, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

export default useDeleteAttachmentsNote;
